import { JSX } from 'react'

import { HttpBody } from '@/lib/request.js'

import * as locally from '@/lib/locally.js'
import * as detective from '@/lib/detective.js'
import * as structure from '@/lib/structure.js'

import * as archive_storage from '@/storage/archive.js'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Loader from '@/components/ui/loader.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Carte from '@/components/ui/carte.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Menu from '@/components/ui/menu.tsx'




export enum Active
{
	view = 'view',
	update = 'update',
	delete = 'delete',

}

export type RetrieveResult = HttpBody<archive_storage.THydratedDocumentType>


// eslint-disable-next-line @typescript-eslint/naming-convention
export function User
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { name, idcard, user } = props.value

	return (
		<Carte.Posy
			name={name}
			text={user?.phone ?? '未知号码'}
			avatar={user?.avatar || idcard}
			// eslint-disable-next-line @typescript-eslint/naming-convention
			w={{ 'base': 24, '2xl': 48 }}
			size="2xl"

		/>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Age
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { age } = props.value

	return (
		// eslint-disable-next-line @typescript-eslint/naming-convention
		<Carte.Feild label="年龄" w="24" display={{ 'base': 'none', '2xl': 'flex' }}>
			<Carte.B>{age}</Carte.B>

		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Sex
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { sex } = props.value

	return (
		<Carte.Feild label="性别" w="24" display={{ base: 'none', xl: 'flex' }}>
			<Carte.B>{sex}</Carte.B>

		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Company
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let name = props.value.contract?.company?.name ?? ''

	return (
		<Carte.Feild label="所属项目" w="72" align="start" boxSizing="content-box">
			<Carte.B>{name || '尚未签约'}</Carte.B>

		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Office
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let office = props.value?.contract?.office ?? ''

	return (
		<Carte.Feild label="岗位" w="32">
			<Carte.B>{office || '无'}</Carte.B>

		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Insurance (
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let insurance = props.value?.contract?.insurance ?? ''

	return (
		<Carte.Feild label="险种" w="32">
			<Carte.B>{insurance || '无'}</Carte.B>

		</Carte.Feild>

	)

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Finish
(
	props: {
		value: RetrieveResult

	},

)
:	JSX.Element
{
	let { contract } = props.value

	let date = '无'
	let lave = ''

	if (detective.is_required_string(contract?.finish) )
	{
		date = locally.date(contract.finish, { format: 'YYYY.MM.DD' })

	}

	if (detective.is_number(contract?.lave) && contract.lave > 0)
	{
		lave = `(${contract.lave}天)`

	}

	return (
		<Carte.Feild label="协议至" flex="auto" minW="36" align="start">
			<Carte.B>{date}</Carte.B>
			<Carte.Span>{lave}</Carte.Span>

		</Carte.Feild>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Item
(
	props: {
		value: RetrieveResult

		view?(_id: string): void
		update?(_id: string): void
		delete?(_id: string, name: string): void

	},

)
:	JSX.Element
{
	let { _id, name } = props.value

	let on_active = (v: Active): void =>
	{
		if (v === Active.view)
		{
			props.view?.(_id)

		}

		if (v === Active.update)
		{
			props.update?.(_id)

		}

		if (v === Active.delete)
		{
			props.delete?.(_id, name)

		}

	}

	return (
		<Loader.Item
			display="flex"
			alignItems="center"
			p="4"
			bg="white"
			shadow="sm"
			rounded="md"
			minW="fit-content"
			_hover={{ bg: 'bg.subtle' }}
		>
			<User value={props.value} />
			<Age value={props.value} />
			<Sex value={props.value} />

			<Carte.Divider />

			<Company value={props.value} />
			<Office value={props.value} />
			<Insurance value={props.value} />
			<Finish value={props.value} />

			<Menu.Root icon={<Menu.Icon />} active={on_active}>
				<Menu.Item value={Active.view}>查看</Menu.Item>
				<Menu.Item value={Active.update}>更新</Menu.Item>

				<Menu.Item value={Active.delete} color="fg.error" _hover={{ bg: 'bg.error', color: 'fg.error' }}>注销</Menu.Item>

			</Menu.Root>

		</Loader.Item>

	)

}


export default function
(
	props: {
		keyword: string

		view?(_id: string): void
		update?(_id: string): void
		delete?(_id: string, name: string): void

	},

)
:	JSX.Element
{
	let on_view = (id: string): void =>
	{
		props.view?.(id)

	}

	let on_update = (id: string): void =>
	{
		props.update?.(id)

	}

	let on_delete = (id: string, name: string): void =>
	{
		props.delete?.(id, name)

	}

	return (
		<Loader.Root
			display="flex"
			flexDirection="column"
			gap="4"
			handle={archive_storage.retrieves}
			params={structure.pick(props, 'keyword')}
		>
			{v => <Item key={v._id} value={v} view={on_view} update={on_update} delete={on_delete} />}

		</Loader.Root>

	)


}
